export enum LottieIconNames {
  CIRCULAR_GRADIENT,
  DYNAMIC_PRICING,
  SCRAPER_AGENT,
  SEARCH_AGENT,
  SICHERO,
  CAREER,
  ARROW_DOWN,
  CONTACT,
  BLOG,
  ABOUT_US,
  PRODUCTS,
  SEARCH_AGENT_PAGE,
  COINS,
  TROLLEY,
  DYNAMIC_PRICING_PAGE,
  LOCATION,
  CIRCLE,
  EARTH,
  SALES_AGENT_PAGE,
  DOCUMENT,
  LAYERS,
  BAR_CHARTS,
  PRIVACY_POLICY,
}

export enum Locales {
  DE = "de",
  EN = "en",
}

export enum EmploymentTypes {
  FULL_TIME,
  HALF_TIME,
  CONTACT,
  REMOTE,
}

export enum ModalIDs {
  SECTION_CREATION_MODAL = "sectionCreationModal",
}

export type CareerType = {
  id: string;
  title: string;
  responsibilities: string[];
  requirements: string[];
  employmentType: EmploymentTypes;
  location: string;
  deadline: string;
};

export type BlogType = {
  id: string;
  title: string;
  date: string;
  description: string;
  tags: string[];
  image?: File;
  imagePath?: string;
  section?: string;
};

export type SelectOptionType<T> = {
  label: string;
  value: T;
};
